import React from 'react'

import { OptionProps } from 'components_new/molecules/OptionsMenu'
import OptionsMenuButton from 'components_new/molecules/OptionsMenuButton'

export interface FormulaTypeButtonProps {
  /** What the operand can be changed into. */
  options: OptionProps[]
  sx?: object
}

/**
 * Changes what an operand is, from inside the field that edits it — the pencil
 * sits where the field's own icon would be.
 */
const FormulaTypeButton = (props: FormulaTypeButtonProps) => {
  const { options, sx } = props

  return (
    <OptionsMenuButton
      iconName="Edit"
      options={options}
      size="xsmall"
      sx={sx}
      variant="icon"
    />
  )
}

export default FormulaTypeButton
